import _ from 'lodash';
import { useMemo } from 'react';

import { AutoAwesomeOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useEarningsCallSummaryButtonQuery } from 'generated/graphql';



export type EarningsCallSummaryButtonProps = {
  companyId: string;
  // Earnings call summaries and risk assessments leads to the same place. Uses the same button with
  // different text.
  isRiskAssessment?: boolean;
  variant: 'chat' | 'companyProfile';
  onClick?: () => void;
};

export const FC = ({
  companyId, isRiskAssessment, variant, onClick
}: EarningsCallSummaryButtonProps) => {
  const {
    data, loading
  } = useEarningsCallSummaryButtonQuery({
    variables: {
      listedCompanyId: companyId
    }
  });

  const hasSummary = useMemo(() => {
    return !loading && !_.isNil(data?.listedCompany?.earningsSummary);
  }, [
    data?.listedCompany?.earningsSummary,
    loading
  ]);

  const sx = variant === 'companyProfile' ? {
  } : {
    backgroundColor: '#D4AF37',
    boxShadow: '#D4AF37 0px 2px 2px 0px',
    borderRadius: '8px'
  };

  const buttonText = useMemo(() => {
    if (loading) {
      return 'Retrieving...';
    }

    if (hasSummary) {
      return isRiskAssessment ? 'Sherlocks Risk Assessment' : 'Earnings Call Analysis';
    }

    return isRiskAssessment ? 'Risk assessment not available' : 'Summary not available';
  }, [
    hasSummary,
    isRiskAssessment,
    loading
  ]);

  return (
    <Button
      disabled={loading || !hasSummary}
      size='small'
      sx={sx}
      variant='contained'
      endIcon={!loading && hasSummary && <AutoAwesomeOutlined fontSize='small' />}
      onClick={onClick ? onClick : () => {
        window.open(`/company/${companyId}/earningsCall`, '_blank');
      }}
    >
      {buttonText}
    </Button>
  );
};

